import axios from "axios";

const API_URL = process.env.VUE_APP_API_URL;

class CatalogsService{

    getCatalogs(token, codLang){     
        return axios({
            method: 'get',
            url: API_URL + 'cataloghi/GetCataloghiByLingua', 
            params:{
                codiceLingua: codLang
            },           
            headers:{
                    Authorization: 'Bearer '+ token,
                    'Content-Type': 'application/json'
            }            
        }).then(
            data =>  {               
                if(data.status == 401){
                    return null;
                }
                else{                    
                    return data.data;
                }               
            }
        )
        .catch(error => {return error;});            
    }
}

export default new CatalogsService();